export enum LicenceStatus {
  processing = 'processing',
  approved = 'approved',
  noLicence = 'noLicence',
  expired = 'expired',
}
